export var getClientGeoLocation = function (options) {
  return new Promise(function (resolve, reject) {
    navigator.geolocation.getCurrentPosition(resolve, function (_a) {
      var code = _a.code,
        message = _a.message;
      return reject(Object.assign(new Error(message), {
        name: 'PositionError',
        code: code
      }));
    }, options);
  });
};
export var LandingPageType;
(function (LandingPageType) {
  LandingPageType["ULTRA_LOCAL"] = "neighborhood";
  LandingPageType["LOCAL"] = "multi_city_vicinity";
})(LandingPageType || (LandingPageType = {}));